<template>
  <div>
    <nav class="nav_mobile_top topPadding">
      <div class="nav_content">
        <div class="nav_left">
          <div class="left_logo">
            <div class="back" v-if="isShowBack" @click="$emit('back')">
              <img src="@/assets/img/icon_back.b2094a45.svg" alt="" />
            </div>
            <div class="logo">
              <div class="logo-container">
                <img src="@/assets/img/logo_img.svg" alt="" />
              </div>
              <span class="nav-title">{{ title }}</span>
            </div>
          </div>
          <!-- <div class="nav_name" @click="$emit('show-drawer')">
            {{ title }}
            <img
              src="@/assets/img/icon_arrow.dc4b9070.svg"
              alt=""
              class="arrow-icon"
			  v-if="currentCode"
            />
          </div> -->
        </div>
        <div class="nav_right" v-if="showRight">
          <!-- <div class="action" @click="isLanguage = true" style="width: auto; border-radius: 5px; padding: 0 5px">
            {{ $t("navTab.language") }}
          </div>
          <div class="action sign" v-if="isLogin" @click="$router.push('/profile/notification')">
            <img src="@/assets/img/icon_bell.28bcd54a.svg" alt="" />
          </div>
          <div class="action sign" @click="openService">
            <img src="@/assets/img/service-m.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
          </div> -->
          <div class="action sign" v-if="showSearch" @click="openSearch">
            <img src="@/assets/img/icon_search.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
          </div>
          <div class="action sign cs-entry" v-if="showService" @click="openService">
            <img src="@/assets/img/service-m.svg" :alt="$t('home.onlineSupport')" />
          </div>
          <div class="action sign notice-container" v-if="showNotice && isLogin" @click="$router.push('/profile/notification')">
            <img src="@/assets/img/icon_notice.svg" :alt="$t('navBottom.bottomCompanyItem4')" />
            <div class="notice-red-dot" v-if="hasNotice"></div>
          </div>
          <div class="action sign" v-if="showCollect" @click="$emit('toggle-collect')">
            <img :src="collected ? collectActiveIcon : collectIcon" :alt="$t('Market.watchlist')" />
          </div>
          <div class="action btn sign" @click="$router.push('/pass/login')" v-if="!isLogin">
            {{ $t("login.btnLogin") }}
          </div>
          <div v-if="showUserName && isLogin" class="user_name">{{ getUserInfo && getUserInfo.id ? getUserInfo.id : '' }}</div>
        </div>
      </div>

      <div class="search-main" v-show="searchShow" @click="searchShow = false">
        <div class="content" id="content" @click.stop>
          <div class="search-input">
            <img src="@/assets/img/icon_search.9fcf95f5.svg" alt="">
            <input
              type="text"
              v-model="searchQuery"
              :placeholder="$t('souSuo')"
            />
          </div>
          <div class="hr"></div>
          <div class="search-reault" :class="{ 'search-reault--list': filteredMarketList.length > 0 }">
            <div v-if="filteredMarketList.length">
              <div
                class="result-list"
                v-for="item in filteredMarketList"
                :key="item.id"
                @click="goToMarket(item)"
              >
                <div class="list-title">
                  <img v-if="item.logo" :src="item.logo" alt="" />
                  {{ item.appName || item.name || item.code }}
                </div>
                <div class="list-number">{{ item.nowPrice }}</div>
                <div class="list-cent" :class="{ 'list-cent1': Number(item.zdf) < 0 }">{{ item.zdf }}%</div>
              </div>
            </div>
            <div v-else-if="searchQuery.trim()">{{ $t('toast.nothingfound') }}</div>
          </div>
        </div>
      </div>
    </nav>

    <Languages :isPc="isPc" :isLanguage="isLanguage" @close="isLanguage = false" />
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Languages from "@/components/Languages.vue";
import { openCustomerService } from '@/utils/customerService';
import { listMarketByType } from "@/api/market.js";
import collectIcon from "@/assets/img/icon_collect.svg";
import collectActiveIcon from "@/assets/img/icon_collect1.svg";

export default {
  name: "HomeView",
  data() {
    return {
      isLanguage: false,
      showDrawer: false,
      searchQuery: "",
      marketList: [],
      currentCode: "",
      searchShow: false,
      marketListLoading: false,
      collectIcon,
      collectActiveIcon,
    };
  },
  props: {
    title: {
      type: String,
      default: "IC Markets",
    },
    showRight: {
      type: Boolean,
      default: true,
    },
    showNotice: {
      type: Boolean,
      default: true,
    },
    showSearch: {
      type: Boolean,
      default: true,
    },
    showUserName: {
      type: Boolean,
      default: true,
    },
    isShowBack: {
      type: Boolean,
      default: false,
    },
    hasNotice: {
      type: Boolean,
      default: false,
    },
    showCollect: {
      type: Boolean,
      default: false,
    },
    collected: {
      type: Boolean,
      default: false,
    },
    showService: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState(["isLogin", "isPc"]),
    ...mapGetters(["getUserInfo", "getMarkTypeList"]),
    getTitle() {
      return this.$route.meta.title;
    },
    filteredMarketList() {
      const query = (this.searchQuery || "").trim().toLowerCase();
      if (!query) {
        return [];
      }
      return this.marketList.filter((item) => this.matchMarketItem(item, query));
    },
  },
  components: {
    Languages,
  },
  mounted() {
    this.currentCode = this.$route.query.code || "";
  },
  methods: {
    matchMarketItem(item, query) {
      const fields = [item.appName, item.name, item.code];
      return fields.some((field) => {
        if (field == null || field === "") return false;
        return String(field).toLowerCase().includes(query);
      });
    },
    async loadAllMarkets() {
      if (this.marketListLoading || this.marketList.length > 0) {
        return;
      }
      this.marketListLoading = true;
      try {
        const types = (this.getMarkTypeList || []).map((t) => t.value);
        const responses = await Promise.all(
          types.map((type) => listMarketByType({ type }))
        );
        const map = new Map();
        responses.forEach((res) => {
          (res.result || []).forEach((item) => {
            if (!map.has(item.id)) {
              map.set(item.id, {
                ...item,
                nowPrice: item.price,
                zdf: item.zdf != null ? (item.zdf * 100).toFixed(2) : "0.00",
              });
            }
          });
        });
        this.marketList = Array.from(map.values());
      } catch (e) {
        console.error("加载市场产品失败:", e);
        this.marketList = [];
      } finally {
        this.marketListLoading = false;
      }
    },
    openSearch() {
      this.searchShow = !this.searchShow;
      if (this.searchShow) {
        this.loadAllMarkets();
      } else {
        this.searchQuery = "";
      }
    },
    goToMarket(item) {
      this.searchShow = false;
      this.searchQuery = "";
      this.$router.push({
        name: "cruuency",
        query: {
          code: item.code,
          type: item.type,
          id: item.id,
        },
      }).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    openService() {
      openCustomerService(this);
    },
    selectCurrency(item) {
      if (item.code === this.$route.query.code) {
        return;
      }
      this.$router.replace({
        path: "/cruuency",
        query: {
          code: item.code,
          type: item.type,
          id: item.id,
        },
      });
      this.showDrawer = false;
      this.currentCode = item.code;
    },
  },
};
</script>
<style lang="scss">
.user_name {
  font-size: .16rem;
  color: #454545;
  width: .91rem;
  border-radius: .4rem;
  border: .02rem solid #000;
  box-sizing: border-box;
  height: .36rem;
  margin-left: .1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav_mobile_top {
  position: fixed;
  top: 0;
  left: 0;
  /* height: 0.36rem; */
  width: 100%;
  background: #fff;
  padding: 0.22rem 0;
  z-index: 11;
}

.nav_mobile_top.topPadding {
  padding: 0.27rem 0 0.27rem 0;
}

.nav_mobile_top .nav_content {
  padding: 0 0.24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* 增强不同设备的兼容性 */
  min-height: 0.36rem;
  box-sizing: border-box;
}

.nav_mobile_top .nav_content .nav_left {
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
  /* 确保在所有设备上正确对齐 */
  min-height: 0.36rem;

  .left_logo {
    display: flex;
    align-items: center;
    /* 增强垂直对齐 */
    height: 0.36rem;
    line-height: 1;
  }
}

.nav_mobile_top .nav_content .nav_left .back {
  margin-right: 0.1rem;
  width: 0.36rem;
  height: 0.36rem;
  box-sizing: border-box;
  border-radius: 50%;
  border: 0.02rem solid #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav_mobile_top .nav_content .nav_left .logo {
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  /* 增强垂直对齐兼容性 */
  line-height: 1;

  .logo-container {
    width: 0.36rem;
    height: 0.36rem;
    /* 修复背景图片显示问题 */
    background: url('@/assets/img/logo_img.svg') no-repeat center center;
    background-size: contain;
    margin-right: 0.06rem;
    /* 确保在所有设备上正确显示 */
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-title {
    color: #000;
    font-size: 0.24rem;
    font-weight: bolder;
    letter-spacing: normal;
    /* 增强垂直对齐 */
    line-height: 1.2;
    display: flex;
    align-items: center;
    /* 防止文字换行 */
    white-space: nowrap;
  }

  /* 保持向后兼容 */
  span {
    font-size: 0.24rem;
    font-weight: bolder;
    letter-spacing: normal;
    line-height: 1.2;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}

.nav_mobile_top .nav_content .nav_left .back img {
  width: 0.16rem;
  height: auto;
}

.nav_mobile_top .nav_content .nav_left .logo {
  margin-right: 0.08rem;
  height: 0.36rem;
}

.nav_mobile_top .nav_content .nav_left .logo img {
  height: 100%;
  width: auto;
}

.nav_mobile_top .nav_content .nav_left .nav_name {
  /* padding-bottom: 0.04rem; */
  font-weight: 700;
  font-size: 0.22rem;
  color: #000;
  display: flex;
  align-items: center;
  cursor: pointer;

  .arrow-icon {
    width: 0.16rem;
    height: 0.16rem;
    margin-left: 0.08rem;
  }
}

.nav_mobile_top .nav_content .nav_right {
  display: flex;
}

.nav_mobile_top .nav_content .nav_right .action {
  margin-left: 0.12rem;
  width: 0.36rem;
  height: 0.36rem;
  border: 0.02rem solid #000;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav_mobile_top .nav_content .nav_right .action.btn {
  width: auto;
  border: none;
  font-weight: 700;
  font-size: 0.22rem;
  color: #000;
}

.nav_mobile_top .nav_content .nav_right .action.sign {
  position: relative;
  margin-left: 0.1rem;
}

.nav_mobile_top .nav_content .nav_right .action.sign img {
  width: 0.24rem;
  height: 0.24rem;
  display: block;
  object-fit: contain;
}

.nav_mobile_top .nav_content .nav_right .action.sign .dot {
  position: absolute;
  top: -0.02rem;
  right: 0;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  background: #ff5858;
}

.search-main {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 12;
  line-height: 100%;
  overflow-y: auto;
}

.search-main .content {
  background: #fff;
  border-radius: 0.16rem;
  width: 3.8rem;
  min-height: 2.62rem;
  margin: auto;
  margin-top: 0.62rem;
  padding-top: 0.24rem;
  padding-bottom: 0.16rem;
  margin-bottom: 0.9rem;
}

.search-main .content .search-input {
  height: 0.26rem;
  margin: auto;
  margin-bottom: 0.1rem;
  width: 3.5rem;
}

.search-main .content .search-input input {
  width: 3.1rem;
}

.search-main .content .search-input img {
  vertical-align: middle;
}

.search-main .content .hr {
  width: 3.48rem;
  height: 0.01rem;
  border-bottom: 0.01rem solid rgba(0, 0, 0, 0.1);
  margin: auto;
  margin-bottom: 0.14rem;
}

.search-main .content .search-reault {
  width: 3.5rem;
  margin: auto;
  text-align: center;
  min-height: 2rem;
  line-height: 2rem;
  font-weight: 400;
  font-size: 0.2rem;
}

.search-main .content .search-reault.search-reault--list {
  line-height: normal;
  text-align: left;
}

.search-main .content .search-reault .result-list {
  width: 100%;
  height: 0.58rem;
  padding: 0 0.23rem 0 0.16rem;
  line-height: 0.58rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.04rem;
  background: #000;
  border-radius: 0.16rem;
}

.search-main .content .search-reault .result-list .list-title {
  font-weight: 500;
  font-size: 0.12rem;
  color: #fff;
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-title img {
  margin-right: 0.08rem;
  height: 0.22rem;
  vertical-align: middle;
}

.search-main .content .search-reault .result-list .list-number {
  font-weight: 400;
  font-size: 0.12rem;
  color: hsla(0, 0%, 100%, 0.5);
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-cent {
  font-weight: 400;
  font-size: 0.12rem;
  color: #9ee970;
  line-height: 0.58rem;
}

.search-main .content .search-reault .result-list .list-cent1 {
  color: #ff2828;
}

.currency-drawer {
  background: #fff;

  ::v-deep .el-drawer__header {
    margin-bottom: 0 !important;
    padding: 20px;
  }

  .search-wrapper {
    padding: 0 20px;

    .market-search {
      width: 100%;

      ::v-deep .el-input__inner {
        border-radius: 4px;
        height: 36px;

        &:focus {
          border-color: #409eff;
        }
      }
    }
  }

  .drawer-content {
    padding: 0 20px;

    .market-list {
      .market-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        cursor: pointer;
        border-bottom: 1px solid #f5f5f5;

        &:hover {
          background-color: #f5f7fa;
        }

        &.active {
          background-color: #f5f7fa;
        }

        .item-left {
          display: flex;
          align-items: center;

          .currency-icon {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }

          .currency-name {
            font-size: 14px;
            color: #333;
          }
        }

        .item-right {
          text-align: right;

          .currency-price {
            display: block;
            font-size: 14px;
            color: #333;
            margin-bottom: 4px;
          }

          .currency-change {
            font-size: 12px;

            &.up {
              color: #67c23a;
            }

            &.down {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}

/* 通知红点样式 */
.notice-container {
  position: relative;
}

.notice-red-dot {
  position: absolute;
  top: 0.02rem;
  right: 0.02rem;
  width: 0.08rem;
  height: 0.08rem;
  background: #ff4343;
  border-radius: 50%;
  z-index: 1;
}
</style>
